import { MoldSection, MoldQuestion } from '@/types/mold-assessment';

// Symptom Categories with Questions
// Each question has severity weight: 1 (mild), 2 (moderate), 3 (severe/specific to mold)

export const MOLD_ASSESSMENT_SECTIONS: MoldSection[] = [
  {
    id: 'respiratory',
    title: 'Respiratory & Sinus Symptoms',
    description: 'Check all symptoms you experience regularly',
    category: 'respiratory',
    questions: [
      { id: 'resp-1', text: 'Chronic sinus congestion or pressure', category: 'respiratory', severity: 2, questionType: 'checkbox' },
      { id: 'resp-2', text: 'Difficulty breathing or shortness of breath', category: 'respiratory', severity: 3, questionType: 'checkbox' },
      { id: 'resp-3', text: 'Persistent cough (dry or productive)', category: 'respiratory', severity: 2, questionType: 'checkbox' },
      { id: 'resp-4', text: 'Wheezing or chest tightness', category: 'respiratory', severity: 3, questionType: 'checkbox' },
      { id: 'resp-5', text: 'Frequent nosebleeds', category: 'respiratory', severity: 2, questionType: 'checkbox' },
      { id: 'resp-6', text: 'Post-nasal drip that won\'t go away', category: 'respiratory', severity: 2, questionType: 'checkbox' },
    ],
  },
  {
    id: 'brain',
    title: 'Brain & Cognitive Symptoms',
    description: 'Check all symptoms you experience regularly',
    category: 'brain',
    questions: [
      { id: 'brain-1', text: 'Brain fog or difficulty thinking clearly', category: 'brain', severity: 3, questionType: 'checkbox' },
      { id: 'brain-2', text: 'Memory problems or forgetfulness', category: 'brain', severity: 3, questionType: 'checkbox' },
      { id: 'brain-3', text: 'Difficulty concentrating or focusing', category: 'brain', severity: 2, questionType: 'checkbox' },
      { id: 'brain-4', text: 'Word-finding difficulties', category: 'brain', severity: 3, questionType: 'checkbox' },
      { id: 'brain-5', text: 'Confusion or disorientation', category: 'brain', severity: 3, questionType: 'checkbox' },
    ],
  },
  {
    id: 'neuro_pain',
    title: 'Neurological - Pain & Sensation',
    description: 'Check all symptoms you experience regularly',
    category: 'neuro_pain',
    questions: [
      { id: 'neuro-p-1', text: 'Frequent headaches or migraines', category: 'neuro_pain', severity: 2, questionType: 'checkbox' },
      { id: 'neuro-p-2', text: 'Tingling or numbness in hands/feet', category: 'neuro_pain', severity: 3, questionType: 'checkbox' },
      { id: 'neuro-p-3', text: 'Burning or "pins and needles" sensations', category: 'neuro_pain', severity: 3, questionType: 'checkbox' },
      { id: 'neuro-p-4', text: 'Nerve pain or shooting pains', category: 'neuro_pain', severity: 3, questionType: 'checkbox' },
      { id: 'neuro-p-5', text: 'Ice pick or stabbing headaches', category: 'neuro_pain', severity: 3, questionType: 'checkbox' },
    ],
  },
  {
    id: 'neuro_movement',
    title: 'Neurological - Movement',
    description: 'Check all symptoms you experience regularly',
    category: 'neuro_movement',
    questions: [
      { id: 'neuro-m-1', text: 'Muscle tremors or twitching', category: 'neuro_movement', severity: 3, questionType: 'checkbox' },
      { id: 'neuro-m-2', text: 'Internal vibrations or buzzing feeling', category: 'neuro_movement', severity: 3, questionType: 'checkbox' },
      { id: 'neuro-m-3', text: 'Muscle weakness', category: 'neuro_movement', severity: 2, questionType: 'checkbox' },
      { id: 'neuro-m-4', text: 'Balance problems or dizziness', category: 'neuro_movement', severity: 3, questionType: 'checkbox' },
      { id: 'neuro-m-5', text: 'Vertigo or room spinning', category: 'neuro_movement', severity: 3, questionType: 'checkbox' },
    ],
  },
  {
    id: 'musculoskeletal',
    title: 'Musculoskeletal Pain',
    description: 'Check all symptoms you experience regularly',
    category: 'musculoskeletal',
    questions: [
      { id: 'muscle-1', text: 'Widespread muscle pain or aches', category: 'musculoskeletal', severity: 2, questionType: 'checkbox' },
      { id: 'muscle-2', text: 'Joint pain or stiffness', category: 'musculoskeletal', severity: 2, questionType: 'checkbox' },
      { id: 'muscle-3', text: 'Morning stiffness lasting more than an hour', category: 'musculoskeletal', severity: 2, questionType: 'checkbox' },
      { id: 'muscle-4', text: 'Muscle cramps or spasms', category: 'musculoskeletal', severity: 2, questionType: 'checkbox' },
      { id: 'muscle-5', text: 'Pain that moves around the body', category: 'musculoskeletal', severity: 3, questionType: 'checkbox' },
    ],
  },
  {
    id: 'energy',
    title: 'Energy & Sleep',
    description: 'Check all symptoms you experience regularly',
    category: 'energy',
    questions: [
      { id: 'energy-1', text: 'Chronic fatigue that rest doesn\'t improve', category: 'energy', severity: 3, questionType: 'checkbox' },
      { id: 'energy-2', text: 'Feeling exhausted after minimal activity', category: 'energy', severity: 3, questionType: 'checkbox' },
      { id: 'energy-3', text: 'Difficulty falling asleep', category: 'energy', severity: 1, questionType: 'checkbox' },
      { id: 'energy-4', text: 'Waking frequently during the night', category: 'energy', severity: 2, questionType: 'checkbox' },
      { id: 'energy-5', text: 'Unrefreshing sleep (wake up tired)', category: 'energy', severity: 3, questionType: 'checkbox' },
    ],
  },
  {
    id: 'skin',
    title: 'Skin, Hair & Nails',
    description: 'Check all symptoms you experience regularly',
    category: 'skin',
    questions: [
      { id: 'skin-1', text: 'Unexplained rashes or skin irritation', category: 'skin', severity: 2, questionType: 'checkbox' },
      { id: 'skin-2', text: 'Hives or itchy skin', category: 'skin', severity: 2, questionType: 'checkbox' },
      { id: 'skin-3', text: 'Unusual hair loss or thinning', category: 'skin', severity: 2, questionType: 'checkbox' },
      { id: 'skin-4', text: 'Brittle or discolored nails', category: 'skin', severity: 2, questionType: 'checkbox' },
      { id: 'skin-5', text: 'Skin that\'s slow to heal', category: 'skin', severity: 2, questionType: 'checkbox' },
    ],
  },
  {
    id: 'digestive',
    title: 'Digestive System',
    description: 'Check all symptoms you experience regularly',
    category: 'digestive',
    questions: [
      { id: 'digest-1', text: 'Bloating or abdominal distension', category: 'digestive', severity: 2, questionType: 'checkbox' },
      { id: 'digest-2', text: 'Nausea or loss of appetite', category: 'digestive', severity: 2, questionType: 'checkbox' },
      { id: 'digest-3', text: 'Diarrhea or constipation (or alternating)', category: 'digestive', severity: 2, questionType: 'checkbox' },
      { id: 'digest-4', text: 'Abdominal pain or cramping', category: 'digestive', severity: 2, questionType: 'checkbox' },
      { id: 'digest-5', text: 'New food sensitivities or intolerances', category: 'digestive', severity: 3, questionType: 'checkbox' },
    ],
  },
  {
    id: 'hormonal',
    title: 'Hormonal & Metabolic',
    description: 'Check all symptoms you experience regularly',
    category: 'hormonal',
    questions: [
      { id: 'hormone-1', text: 'Unexplained weight gain or loss', category: 'hormonal', severity: 2, questionType: 'checkbox' },
      { id: 'hormone-2', text: 'Temperature regulation issues (always hot or cold)', category: 'hormonal', severity: 2, questionType: 'checkbox' },
      { id: 'hormone-3', text: 'Night sweats', category: 'hormonal', severity: 2, questionType: 'checkbox' },
      { id: 'hormone-4', text: 'Increased thirst or frequent urination', category: 'hormonal', severity: 2, questionType: 'checkbox' },
      { id: 'hormone-5', text: 'Menstrual irregularities (if applicable)', category: 'hormonal', severity: 2, questionType: 'checkbox' },
      { id: 'hormone-6', text: 'Low libido or hormonal imbalances', category: 'hormonal', severity: 2, questionType: 'checkbox' },
    ],
  },
  {
    id: 'sensory',
    title: 'Sensory Sensitivities',
    description: 'Check all symptoms you experience regularly',
    category: 'sensory',
    questions: [
      { id: 'sensory-1', text: 'Sensitivity to light (photophobia)', category: 'sensory', severity: 3, questionType: 'checkbox' },
      { id: 'sensory-2', text: 'Sensitivity to sound', category: 'sensory', severity: 2, questionType: 'checkbox' },
      { id: 'sensory-3', text: 'Sensitivity to smells or chemicals', category: 'sensory', severity: 3, questionType: 'checkbox' },
      { id: 'sensory-4', text: 'Blurred vision or visual disturbances', category: 'sensory', severity: 3, questionType: 'checkbox' },
      { id: 'sensory-5', text: 'Ringing in ears (tinnitus)', category: 'sensory', severity: 2, questionType: 'checkbox' },
    ],
  },
  {
    id: 'mood',
    title: 'Mood & Mental Health',
    description: 'Check all symptoms you experience regularly',
    category: 'mood',
    questions: [
      { id: 'mood-1', text: 'Anxiety or panic attacks', category: 'mood', severity: 2, questionType: 'checkbox' },
      { id: 'mood-2', text: 'Depression or low mood', category: 'mood', severity: 2, questionType: 'checkbox' },
      { id: 'mood-3', text: 'Irritability or mood swings', category: 'mood', severity: 2, questionType: 'checkbox' },
      { id: 'mood-4', text: 'Feeling overwhelmed easily', category: 'mood', severity: 2, questionType: 'checkbox' },
      { id: 'mood-5', text: 'Sense of doom or impending dread', category: 'mood', severity: 3, questionType: 'checkbox' },
    ],
  },
  {
    id: 'heart',
    title: 'Heart & Circulation',
    description: 'Check all symptoms you experience regularly',
    category: 'heart',
    questions: [
      { id: 'heart-1', text: 'Rapid heartbeat or palpitations', category: 'heart', severity: 2, questionType: 'checkbox' },
      { id: 'heart-2', text: 'Chest pain or pressure', category: 'heart', severity: 2, questionType: 'checkbox' },
      { id: 'heart-3', text: 'Feeling faint or lightheaded', category: 'heart', severity: 2, questionType: 'checkbox' },
      { id: 'heart-4', text: 'Cold hands and feet', category: 'heart', severity: 1, questionType: 'checkbox' },
    ],
  },
  {
    id: 'environmental',
    title: 'Environmental Factors',
    description: 'These questions help identify potential mold exposure',
    category: 'environmental',
    questions: [
      { id: 'env-1', text: 'Water damage in your home (past or present)', category: 'environmental', severity: 3, questionType: 'checkbox' },
      { id: 'env-2', text: 'Visible mold growth anywhere in your home', category: 'environmental', severity: 3, questionType: 'checkbox' },
      { id: 'env-3', text: 'Musty or moldy smell in your home', category: 'environmental', severity: 3, questionType: 'checkbox' },
      { id: 'env-4', text: 'Leaky roof, pipes, or windows', category: 'environmental', severity: 3, questionType: 'checkbox' },
      { id: 'env-5', text: 'Flooding history in basement or crawl space', category: 'environmental', severity: 3, questionType: 'checkbox' },
      { id: 'env-6', text: 'High humidity in your home (condensation on windows)', category: 'environmental', severity: 2, questionType: 'checkbox' },
      { id: 'env-7', text: 'Symptoms improve when away from home for several days', category: 'environmental', severity: 3, questionType: 'checkbox' },
      { id: 'env-8', text: 'Symptoms worse in certain rooms of your home', category: 'environmental', severity: 3, questionType: 'checkbox' },
      { id: 'env-9', text: 'Other family members or pets have similar symptoms', category: 'environmental', severity: 3, questionType: 'checkbox' },
      { id: 'env-10', text: 'Live in a humid climate or near water', category: 'environmental', severity: 1, questionType: 'checkbox' },
    ],
  },
  {
    id: 'medical_journey',
    title: 'Your Medical Journey',
    description: 'Check all that apply to your experience seeking answers',
    category: 'medical_journey',
    questions: [
      { id: 'med-1', text: 'Seen multiple doctors without answers', category: 'medical_journey', severity: 2, questionType: 'checkbox' },
      { id: 'med-2', text: 'Been told "tests are normal" despite symptoms', category: 'medical_journey', severity: 3, questionType: 'checkbox' },
      { id: 'med-3', text: 'Diagnosed with fibromyalgia, chronic fatigue, or similar', category: 'medical_journey', severity: 2, questionType: 'checkbox' },
      { id: 'med-4', text: 'Spent significant money on treatments without improvement', category: 'medical_journey', severity: 2, questionType: 'checkbox' },
      { id: 'med-5', text: 'Symptoms started or worsened after moving to a new home', category: 'medical_journey', severity: 3, questionType: 'checkbox' },
      { id: 'med-6', text: 'Been made to feel like symptoms are "in your head"', category: 'medical_journey', severity: 2, questionType: 'checkbox' },
    ],
  },
];

// Radio button questions for environmental section
export const HOME_DURATION_OPTIONS = [
  'Less than 6 months',
  '6 months - 1 year',
  '1 - 3 years',
  '3 - 5 years',
  'More than 5 years',
];

export const SYMPTOM_TIMING_OPTIONS = [
  'Before moving to current home',
  'Shortly after moving in (within 6 months)',
  'Gradually developed over time',
  'Started after a water damage event',
  'Not sure / Don\'t remember',
];

// Calculate maximum possible score
export const calculateMaxScore = (): number => {
  let total = 0;
  MOLD_ASSESSMENT_SECTIONS.forEach(section => {
    section.questions.forEach(question => {
      total += question.severity;
    });
  });
  return total;
};

// Get all questions as flat array
export const getAllQuestions = (): MoldQuestion[] => {
  return MOLD_ASSESSMENT_SECTIONS.flatMap(section => section.questions);
};

// Get section by ID
export const getSectionById = (id: string): MoldSection | undefined => {
  return MOLD_ASSESSMENT_SECTIONS.find(section => section.id === id);
};

// Get question by ID
export const getQuestionById = (id: string): MoldQuestion | undefined => {
  return getAllQuestions().find(q => q.id === id);
};

// Total number of sections (for progress bar)
export const TOTAL_STEPS = MOLD_ASSESSMENT_SECTIONS.length + 2; // +2 for additional symptoms and story steps
